import { flowUtils } from '@atlassian/mpac-utils';
export const FREE_PRICING = 'FREE';
export const PAID_PRICING = 'PAID';
export const isFreeApp = p => p === 'free';
export const foldPaymentModel = p => (free, atlassian, vendor) => {
  switch (p) {
    case 'atlassian':
      return atlassian();
    case 'free':
      return free();
    case 'vendor':
      return vendor();
    default:
      throw flowUtils.unexpectedCase(p);
  }
};